import {DAYS_IN_MONTH, HOURS_IN_DAY} from '~/helpers/constants'

const Period = {
  DAY: 'day',
  HOUR: 'hour',
  MONTH: 'month'
}

export default {
  computed: {
    timeMultiplier() {
      let multiplier

      switch (this.currentPeriod) {
        case Period.MONTH:
          multiplier = DAYS_IN_MONTH * HOURS_IN_DAY

          break
        case Period.DAY:
          multiplier = HOURS_IN_DAY

          break
        case Period.HOUR:
          multiplier = 1
      }

      return multiplier
    }
  }
}